import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Router from './components/Router';
import store from './config/Store';
import './_assets/base.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faCheckSquare,
	faCoffee,
	faChartLine,
	faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import registerServiceWorker from './registerServiceWorker';

library.add(faCheckSquare, faCoffee, faChartLine, faCheckCircle);

ReactDOM.render(
	<Provider store={store}>
		<Router />
	</Provider>,
	document.getElementById('root'),
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js